import React from 'react'
import { useFieldArray, useWatch } from 'react-hook-form'
import { useSelector } from 'react-redux'

// UI
import { Card } from '@/components/Elements/'
import { Input, Select } from '@/components/Form'
import { offerQuotationGroupPolicyType } from '@/features/offers/constants/offerEditRights/offerQuotationEditRights'
import { selectOfferPermissions } from '@/features/offers/slices/offerDetail.slice'
import { Box, Button, Flex, HStack, Heading, Text } from '@chakra-ui/react'

const SystemInfo = ({ subSystemIndex }) => {
  const offerPermissions = useSelector(selectOfferPermissions)

  const {
    fields: systemFields,
    append: appendSystem,
    remove: removeSystem,
  } = useFieldArray({
    name: `subSystems.${subSystemIndex}.system`,
  })

  const systems = useWatch({ name: `subSystems.${subSystemIndex}.system` })
  const canEditSubSystem = offerPermissions[offerQuotationGroupPolicyType.QUOTATION_SUB_SYSTEM]?.edit ?? false

  return (
    <Card
      title={'System'}
      hasBorder={false}
      rightElement={
        canEditSubSystem && (
          <Button colorScheme="green" size="sm" onClick={() => appendSystem({ type: '', subType: '', other: '' })}>
            Add
          </Button>
        )
      }
    >
      <Flex direction="column" gap={3}>
        {systemFields.map((system, i) => (
          <HStack key={system.id}>
            <Flex justifyContent={'flex-start'}>
              <Heading w="100px" size="sm">
                Type
              </Heading>
              <Text color="red">*</Text>
            </Flex>
            <Box w="200px">
              <Select
                name={`subSystems.${subSystemIndex}.system.${i}.type`}
                disabled={!canEditSubSystem}
                options={[
                  { value: 'BMS', label: 'BMS' },
                  { value: 'PLC', label: 'PLC' },
                  { value: 'FS', label: 'FS' },
                  { value: 'SES', label: 'SES' },
                  { value: 'other', label: 'other' },
                ]}
              />
            </Box>
            {systems[i]?.type === 'BMS' && (
              <Box w="200px">
                <Select
                  name={`subSystems.${subSystemIndex}.system.${i}.subType`}
                  disabled={!canEditSubSystem}
                  options={[
                    { value: 'desigoCC', label: 'DesigoCC' },
                    { value: 'insightApogee', label: 'Insight Apogee' },
                  ]}
                />
              </Box>
            )}
            {systems[i]?.type === 'PLC' && (
              <Box w="200px">
                <Select
                  name={`subSystems.${subSystemIndex}.system.${i}.subType`}
                  disabled={!canEditSubSystem}
                  options={[
                    { value: 'SCADA', label: 'SCADA' },
                    { value: 'other', label: 'Other' },
                  ]}
                />
              </Box>
            )}
            {systems[i]?.type === 'PLC' && systems[i].subType === 'other' && (
              <Box w="200px">
                <Input
                  name={`subSystems.${subSystemIndex}.system.${i}.other`}
                  disabled={!canEditSubSystem}
                  type="text"
                  placeholder="Enter value"
                />
              </Box>
            )}
            {systems[i]?.type === 'FS' && (
              <Box w="200px">
                <Select
                  name={`subSystems.${subSystemIndex}.system.${i}.subType`}
                  disabled={!canEditSubSystem}
                  options={[
                    { value: 'desigoCC', label: 'DesigoCC' },
                    { value: 'sinteso', label: 'Sinteso' },
                    { value: 'XLS', label: 'XLS' },
                    { value: 'algorex', label: 'Algorex' },
                    {
                      value: 'fireExtinguisher',
                      label: 'Fire Extinguisher',
                    },
                    { value: 'wetSystem', label: 'Wet System' },
                  ]}
                />
              </Box>
            )}
            {systems[i]?.type === 'SES' && (
              <Box w="200px">
                <Select
                  name={`subSystems.${subSystemIndex}.system.${i}.subType`}
                  disabled={!canEditSubSystem}
                  options={[
                    { value: 'desigoCC', label: 'DesigoCC' },
                    { value: 'siPass', label: 'SiPass' },
                    { value: 'other', label: 'Other' },
                  ]}
                />
              </Box>
            )}
            {systems[i]?.type === 'SES' && systems[i].subType === 'other' && (
              <Box w="200px">
                <Input
                  name={`subSystems.${subSystemIndex}.system.${i}.other`}
                  disabled={!canEditSubSystem}
                  type="text"
                  placeholder="Enter value"
                />
              </Box>
            )}
            {systems[i]?.type === 'other' && (
              <Box w="200px">
                <Input
                  name={`subSystems.${subSystemIndex}.system.${i}.subType`}
                  disabled={!canEditSubSystem}
                  type="text"
                  placeholder="Enter value"
                />
              </Box>
            )}

            {canEditSubSystem && (
              <Button colorScheme="red" onClick={() => removeSystem(i)}>
                Delete
              </Button>
            )}
          </HStack>
        ))}
      </Flex>
    </Card>
  )
}

export default SystemInfo
